const PaywallDivider = () => (
  <span className="h-px w-full shrink-0 bg-[#EBEBEB]" />
);

export default PaywallDivider;
